import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import fonts
import './assets/fonts/barlow-condensed/barlow-condensed.bold.ttf';
import './assets/fonts/barlow-condensed/barlow-condensed.regular.ttf';
import './assets/fonts/barlow-condensed/barlow-condensed.light.ttf';
import './assets/fonts/barlow-condensed/barlow-condensed.medium.ttf';

import './assets/fonts/Barlow/Barlow-Thin.ttf';
import './assets/fonts/Barlow/Barlow-Regular.ttf';
import './assets/fonts/Barlow/Barlow-Bold.ttf';
import './assets/fonts/Barlow/Barlow-SemiBold.ttf';
import './assets/fonts/Barlow/Barlow-Medium.ttf';
import './assets/fonts/Barlow/Barlow-Black.ttf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
